import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiStar, FiUserCheck } = FiIcons;

const About = () => {
  const targets = [
    "Pemilik bisnis lokal / UMKM",
    "Jasa profesional & service-based business",
    "Brand baru yang ingin go digital dengan arah yang jelas",
    "Ingin sistem yang bisa dipakai jangka panjang, bukan sekadar tren"
  ];

  return (
    <section id="about" className="py-24 relative overflow-hidden bg-[#0A192F]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="bg-gradient-to-br from-[#0A192F] to-black border border-white/10 rounded-[4rem] p-10 md:p-20 shadow-2xl overflow-hidden relative">
          <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/10 blur-[100px] -mr-48 -mt-48"></div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-5xl font-black text-white mb-8 leading-tight">
                Cocok Untuk <span className="text-orange-500">Anda Jika:</span>
              </h2>
              <div className="space-y-6">
                {targets.map((item, idx) => (
                  <div key={idx} className="flex items-start space-x-4">
                    <div className="mt-1">
                      <SafeIcon icon={FiUserCheck} className="text-orange-500 text-2xl" />
                    </div>
                    <p className="text-gray-200 text-xl font-bold leading-snug">{item}</p>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="bg-white/5 p-10 rounded-[3rem] border border-white/10 backdrop-blur-md">
               <div className="flex items-center mb-6">
                 <SafeIcon icon={FiStar} className="text-yellow-400 text-3xl mr-4" />
                 <h3 className="text-2xl font-black text-white">Visi Kami</h3>
               </div>
               <p className="text-gray-300 text-lg leading-relaxed font-medium mb-8">
                 Kami tidak hanya ingin Anda "ada" di internet. Kami ingin Anda mendominasi market lokal Anda dengan sistem yang terintegrasi.
               </p>
               <div className="grid grid-cols-2 gap-6">
                 <div className="text-center p-6 bg-white/5 rounded-3xl border border-white/10">
                    <div className="text-3xl font-black text-orange-500 mb-1">100+</div>
                    <div className="text-xs text-gray-400 font-bold uppercase tracking-widest">Projects</div>
                 </div>
                 <div className="text-center p-6 bg-white/5 rounded-3xl border border-white/10">
                    <div className="text-3xl font-black text-orange-500 mb-1">50+</div>
                    <div className="text-xs text-gray-400 font-bold uppercase tracking-widest">Happy Brands</div>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;